  <p-toast></p-toast>
<div
  *ngIf="errorMessages.length > 0"
  class="delegateTemplateSliderErrorMessagePlaceHolder"
>
  <p-messages severity="error">
    <ng-template pTemplate>
      <div class="p-message-wrapper">
        <div>
          <span class="p-message-icon pi pi-times-circle"></span>
          <span class="p-ml-2">{{ errorMessageHeaderText }}</span>
        </div>
        <div>
          <ul>
            <li *ngFor="let errorText of errorMessages">{{ errorText }}</li>
          </ul>
        </div>
      </div>
    </ng-template>
  </p-messages>
</div>

<div class="general-tab">
<form [formGroup]="trainingItemGroupForm">
    <div class="fields-row">
      <div class="field field-required">
        <bpt-text-input
          label="Name"
          formControlName="name"
          [ngClass]="{ 'error-highlight': mandatoryFields['name'] }"
          id="name"
          [required]="true"
        ></bpt-text-input>
      </div>
      <div class="field field-required">
        <bpt-dropdown
          label="eQMS Scope(s)"
          [options]="eQMSScopeList"
          [editable]="false"
          formControlName="eqmsScopes"
          id="courseScope"
          [showClear]="true"
          [showFilter]="true"
          [valueField]="valueField"
          [labelField]="labelField"
          [multiSelect]="true"
          [ngClass]="{ 'error-highlight': mandatoryFields['eqmsScopes'] }"
          [required]="true"
          (ngModelChange)="onEqmsScopesChange()"
        >
        </bpt-dropdown>
    </div>  
  </div>
</form>

<div class="trainingItems">
  <p-fieldset legend="Training Items" [toggleable]="true"  class="first-fieldset">
    <div class="col mb-2">
          <div class="card-container">        
              <div class="items-container" *ngFor="let item of trainingItemsDataToDisplay">
    
                  <div class="overflow-ellipse flex-initial flex underline document-header font-semibold " >
                  <a style="cursor: pointer;" (click)="openDocument(item.number,item.version,item.trainingType)">{{ item?.number }} {{(item.title.length>90)? 
                  (item?.title | slice:0:90)+'..':(item?.title)}} </a>
                  </div>
              <div class="overflow-ellipse flex-initial flex" style="text-align: right;">
                <button pButton pRipple type="button" id="deleteLinkedItemButton" icon="fa fa-trash"
                         class="p-button-rounded p-button-text" appPreventDoubleClick (debounceClick)="showConfirmationPopupForDeletedAttachments(item?.number)"></button>
              </div>
              </div>           
    </div>
    
    <p-dialog
    [(visible)]="showDeleteTrainingItemsConfirmationModal"
    [style]="{ width: '30vw' }"
    (onHide)="closeConfirmationModal()"
    [modal]="true"
    >
    <ng-template pTemplate="header">
    <span class="font-semibold text-xl">Confirmation</span>
    </ng-template>
    <div>
    <em class="pi pi-exclamation-triangle mr-2 font-semibold"></em>
    <span>{{trainingItemsDeleteMessage}}</span>
    </div>
    <ng-template pTemplate="footer">    
    <p-button
    appPreventDoubleClick
      label="No"
      type="submit"
      icon="pi pi-times"
      id="deleteLinkedItemConfirmationNoButton"
      styleClass="p-button-outlined"
      class="align-right"
      (debounceClick)="closeConfirmationModal()"
    >
    </p-button>
    <p-button
    appPreventDoubleClick
      label="Yes"
      icon="pi pi-check"
      type="submit"
      id="deleteLinkedItemConfirmationYesButton"
      class="align-right"
      (debounceClick)="updateSelectedData()"
    >
    </p-button>
    </ng-template>
    </p-dialog>
    
    </div>
  </p-fieldset>

  <p-fieldset legend="Search Training Items" [toggleable]="true"  class="second-fieldset">
    <div class="second-fieldset-content">
      <p-tabView>
      <p-tabPanel  header="Document">
        <div class="content">
          <app-document-library-search #docSearch (shouldAddLinkItemsButtonDisplayed)="isAddTrainingItemsButtonVisible = $event" (emitSelectedData)="trainingItemsSelectedData($event)"
          [panelListScreen]="trainingItemGroupDetails"></app-document-library-search>
        </div>
        <div class="col mb-2" *ngIf="isAddTrainingItemsButtonVisible" >
          <p-button
          appPreventDoubleClick
            label="Add Training Item"
            icon="fa fa-plus"
            id="addCourseItemButton"
            styleClass="p-button-outlined"
            iconPos="left"
            pTooltip="Add Training Item"
            (debounceClick)="addDocumentItems(docSearch)"
            [disabled]="!isEqmsScopesSelected"
            >
          </p-button>
        </div>
      </p-tabPanel>
      <p-tabPanel header="Course">
        <div class="content">
          <app-course-catalogue-search #courseSearch
          (shouldAddTrainingItemAsCourseButtonDisplayed)="isAddCourseItemsButtonVisible = $event"
          (emitSelectedData)="courseItemsSelectedData($event)"
          [enableCheckBoxes]="showCheckBoxes"
          [panelListScreen]="trainingItemGroupDetails"></app-course-catalogue-search></div>
          <div class="col mb-2" *ngIf="isAddCourseItemsButtonVisible" >
            <p-button
            appPreventDoubleClick
              label="Add Training Item"
              icon="fa fa-plus"
              id="addCourseItemButton"
              styleClass="p-button-outlined"
              iconPos="left"
              pTooltip="Add Training Item"
              (debounceClick)="addCourseItems(courseSearch)"
              [disabled]="!isEqmsScopesSelected"
              >
            </p-button>
          </div>
      </p-tabPanel>
    </p-tabView>
    </div>
  </p-fieldset>    
</div>

<div class="button">
  <p-button
  appPreventDoubleClick
    label="Save"
    type="submit"
    id="trainingItemSaveButton"
    class="saveBtn"
    styleClass="bpt-button-compact"
    (debounceClick)="saveTrainingItemGroup()"
  >
  </p-button>
</div>

</div>